import React, { useEffect, useState } from "react"
import classNames from "classnames"
import { useLocation } from "react-router-dom"
import { routes } from "router/routes"
import { BreadCrumbs } from "ui/BreadCrumbs"
import { proMenuList } from "./proMenuList"

export const NavigationPath = ({ className, subPages }) => {
  const [menu, setMenu] = useState()
  const location = useLocation()
  const menuItemsFlat = proMenuList.flatMap((menuItem) => menuItem.items)

  useEffect(() => {
    const menuPath = location.pathname.split(routes.proHomeRootPath()).filter(Boolean)[0]
    const menuId = menuPath?.split("/").filter(Boolean)[0]
    const menu = menuId && menuItemsFlat.find((menuItem) => menuItem.id === menuId)
    setMenu(menu)
  }, [location.pathname, menuItemsFlat])

  if (!menu) {
    return null
  }

  return <BreadCrumbs className={classNames(className)} iconName={menu.iconName} category={menu.name} subPages={subPages} />
}
